import { KeycloakProvider, KeycloakService } from '@elotech/components';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ProtocoloAuthService } from 'service';
import { KeycloakActions } from 'state/actions';

export const ProtocoloKeycloakProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [keycloakLoaded, setKeycloakLoaded] = useState(false);

  const isLogin = useMemo(() => {
    return new URLSearchParams(window.location.search).get('login') === 'true';
  }, []);

  useEffect(() => {
    if (isLogin) {
      const kcInstance = KeycloakService.getInstance().init({
        onLoad: 'check-sso',
        useNonce: false,
        checkLoginIframe: false
      });

      const handler = () => {
        KeycloakService.getInstance()
          .login({
            redirectUri: `${ProtocoloAuthService.getHost()}/protocolo`
          })
          ?.success?.(() => {});
      };

      kcInstance?.then?.(handler);
      kcInstance?.success?.(handler);
    }
  }, [isLogin]);

  const checkUserExists = () => {
    const userExists = {
      payload: {
        userExists: true
      }
    };

    return Promise.resolve(userExists);
  };

  const setUserProfile = useCallback(
    payload => {
      dispatch(KeycloakActions.setUserProfile(payload));
    },
    [dispatch]
  );

  const getUserData = useCallback(
    () => dispatch(KeycloakActions.getUserData()),
    [dispatch]
  );

  return (
    <KeycloakProvider
      keycloakService={KeycloakService}
      loadUserProfile={setUserProfile}
      isKeycloakLoaded={keycloakLoaded}
      setKeycloakLoaded={() => setKeycloakLoaded(true)}
      checkUserExists={checkUserExists}
      getUserData={getUserData}
      onUserNotAuthenticated={() => {
        setKeycloakLoaded(true);
        throw new Error('Você está no Processo Externo!');
      }}
      fastInitialization={!isLogin}
    >
      {children}
    </KeycloakProvider>
  );
};
